export const env = window.config.REACT_APP_ENV;
export const API_URL = window.config.REACT_APP_API_URL;
export const ISSUER = window.config.REACT_APP_ISSUER;
export const CLIENT = window.config.REACT_APP_CLIENT;
export const API_CLIENT = window.config.REACT_APP_API_CLIENT;
export const APP_ENV = window.config.REACT_APP_ENVIRONMENT;